import { Link } from "react-router-dom";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import PageFrame from "./../../../helpers/PageFrame/PageFrame";
import Button from "./../../../components/Button/Button";

const NotFoundPage = () => {
  return (
    <>
      <SiteTitle title="صفحه مورد نظر یافت نشد" />

      <PageFrame>
        <div className="nk-block nk-block-middle wide-md mx-auto">
          <div className="nk-block-content nk-error-ld text-center">
            <img
              className="nk-error-gfx"
              src="/assets/images/gfx/error-404.svg"
              alt="404"
            />
            <div className="wide-xs mx-auto">
              <h3 className="nk-error-title">صفحه مورد نظر یافت نشد</h3>
              <p className="nk-error-text">
                به نظر می رسد که شما سعی دارید به صفحه ای دسترسی پیدا نمایید که
                حذف شده و یا هرگز وجود نداشته
              </p>
              <Link to="/">
                <Button color="primary" size="lg" className="mt-2">
                  بازگشت به خانه
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </PageFrame>
    </>
  );
};

export default NotFoundPage;
